// *******************************************************************************
// Adventure Module
// *******************************************************************************

const adventureModule = document.querySelectorAll('.adventure-module');

if (adventureModule.length > 0) {
  let adventureModuleImage = null;

  const initAdventureScrollMagic = () => {
    adventureModuleImage = new ScrollMagic.Controller();

    adventureModule.forEach((element) => {
      const parentElem = element.closest('.sc-adventure-module');
      const headerEle = parentElem.querySelector('.adventure-module__header');
      const stickyElem = parentElem.querySelector('.adventure-module__sticky');

      const headerHeight = headerEle.getBoundingClientRect().height;
      element.style.setProperty('--adventure-header-height', `${headerHeight}px`);

      new ScrollMagic.Scene({
        triggerElement: stickyElem,
        duration: stickyElem.clientHeight,
        triggerHook: 0,
      })
        .setPin(headerEle)
        .addTo(adventureModuleImage);

      // Image Animation
      const stickyImageElem = parentElem.querySelector('.adventure-module__image-sticky');
      const imageWrapElem = parentElem.querySelector('.adventure-module__image-wrapper');
      const imageElem = parentElem.querySelector('.adventure-module__image');
      const mainImage = parentElem.querySelector('.adventure-module__image--main');

      const imageTween = gsap.timeline();

      imageTween
        .to(
          mainImage,
          {
            transform: 'translate(-50%, -50%) scale(1)',
          },
          0,
        )
        .to(
          imageElem,
          {
            width: `calc(100vw - ${scrollbarSize}px)`,
            height: '100vh',
            x: 0,
            y: 0,
            borderRadius: 0,
          },
          0,
        );

      new ScrollMagic.Scene({
        triggerElement: stickyImageElem,
        duration: stickyImageElem.clientHeight,
        triggerHook: 0,
      })
        .setTween(imageTween)
        .setPin(imageWrapElem)
        .addTo(adventureModuleImage);

      // Text Animation
      const titleEle = headerEle.querySelector('.title');
      const firstTitle = headerEle.querySelector('.title h2 strong');
      const secondTitle = headerEle.querySelector('.title h2');

      const titleTween = gsap.timeline({ defaults: { ease: 'none' } });

      titleTween
        .to(
          firstTitle,
          {
            color: '#D4D4D4',
          },
          0,
        )
        .to(
          secondTitle,
          {
            color: '#262626',
          },
          0,
        );

      new ScrollMagic.Scene({
        triggerElement: titleEle,
        duration: 0,
        triggerHook: 0.5,
        reverse: true,
      })
        .setTween(titleTween)
        .addTo(adventureModuleImage);
      // .addIndicators({ name: 'Sticky Header' });
    });
  };

  initAdventureScrollMagic();
}
